import { goTo, is, xenv, bridge } from '@didi/webx-js'
import mpx from '@mpxjs/core'
import {
  getformateLangMessage,
  getProdConfFromApollo,
} from '../global_env/get_prod_config'
import { URLQueries } from '../global_env/url_query'
import { getAppVersion } from '../global_env/app'
import { EnumProductType } from '../defines/enums'

/**
 * 获取需要跳转主小的xenv信息
 * @param {*} goods 商品信息
 * @returns
 */
export const getMpAppHomeXenvInfo = (goods = {}) => {
  // 下发url / 信贷商品（信贷商品在详情页0元购时会跳转第三方页面）
  if (!(goods.link_url || goods.credit_info?.status === 1)) {
    return {}
  }
  if (is('harmonyos')) {
    return {
      otherDetailPageJumpAppHome: true,
      goodsClickJumpToast:
        '抱歉，当前手机系统不支持该操作，可以在其他设备上登录此账号尝试此操作',
    }
  }
  const goodsClickApllo =
    getProdConfFromApollo(goods.product_type, { searchKey: 'goods_click' }) ||
    {}
  const goodsClickJumpToast = getformateLangMessage(
    goodsClickApllo.jump_third_goods_page_toast
  )
  const goodsClickJumpActivityId =
    goodsClickApllo.jump_third_page_to_activity_id?.trim?.()
  return {
    goodsClickJumpToast,
    goodsClickJumpActivityId,
    otherDetailPageJumpAppHome: !!(
      goodsClickJumpToast ||
      (is('miniprogram') && goodsClickJumpActivityId)
    ),
  }
}

/**
 * @param {*} goToXenvInfo 跳转主小的xenv信息
 * @param {*} params 跳转需携带的参数
 * @returns
 */
export const clickGoodsGuideMpAppHome = (goToXenvInfo = {}, params = {}) => {
  if (goToXenvInfo.goodsClickJumpToast) {
    mpx.showToast({
      title: goToXenvInfo.goodsClickJumpToast,
      icon: 'none',
    })
    return
  }
  if (params?.hideNavigation) {
    delete params?.hideNavigation
  }
  if (goToXenvInfo.goodsClickJumpActivityId) {
    goTo({
      activityId: goToXenvInfo.goodsClickJumpActivityId,
      params,
      extParams: {
        type: 'jump',
      },
    })
  }
}

/**
 * 去打车
 * @param {*} mallData 组件数据
 * @param {*} xspmInfo 九章参数
 * @returns
 */
export const goDaCheF = async ({ productType, apolloPage } = {}, xspmInfo) => {
  const pageConf = getProdConfFromApollo(productType, {
    searchKey: apolloPage,
  })
  const url = pageConf?.dache_btn_link?.trim?.()
  if (url) {
    const loadParams = {
      extParams: {
        h5JumpMethod: 'openPage',
        xspmInfo,
      },
    }
    const appid = pageConf?.dache_btn_appid?.trim?.()
    if (appid) {
      loadParams.appId = appid
    }
    if (url.startsWith('/')) {
      loadParams.path = url
    } else if (/^https?/.test(url)) {
      loadParams.url = url
    } else {
      loadParams.scheme = url
    }
    console.log('-goDaCheF--loadParams', loadParams)
    goTo(loadParams)
    return
  }
  const dacheBtnShowToast = getProdConfFromApollo(productType, {
    searchKey: 'dache_btn_show_toast',
  })
  const noAllowToDacehToastText = getformateLangMessage(dacheBtnShowToast)
  if (noAllowToDacehToastText) {
    mpx.showToast({
      title: noAllowToDacehToastText,
      icon: 'none',
    })
    return
  }
  // 主端和主小顺风车页面，没有任何顺风车来源标识。因此__isBeatles为新顺风车webview标识，__beatlesHome需要回退标识
  // 由于可能会出现缺失参数的情况，因此兜底们只要是顺风车商品都往顺风车首页跳转
  // 本次需求上线后 只会往新webview投放
  if (
    +productType === EnumProductType.Beatles &&
    ['wxmp', 'alimp', 'sfcwxmp', 'sfcalimp', 'passenger'].includes(xenv())
  ) {
    // const sfcWebview =
    //   URLQueries.getQuery('__isBeatles') &&
    //   +URLQueries.getQuery('__isBeatles') === 1
    // na端跳转加上clear_all_page清除历史页面
    if (is('passenger')) {
      const appversion = await getAppVersion()
      if (String(appversion) < '6.6.14') {
        bridge.switchToBusinessPage({
          navi_url: 'onetravel://carmate/entrance',
          clear_all_page: true, // 清历史栈
        })
        return
      }
      bridge.switchToBusinessPage({
        navi_url: 'onetravel://sfc/entrance',
        clear_all_page: true, // 清历史栈
      })
      return
    }
    // 顺风车新webview下小程序直接跳转首页会存在打开两个首页的情况，因此采用回退形式。
    // 由于顺风车首页到->商品详情页 支付中间页->订单详情页 跳转了两个webview，所以需要delta=2
    // navigateTo & redirectTo会打开两个顺风车首页
    // reLaunch 返回时需要点左上角返回按钮才能回退到大首页
    if (is('miniprogram')) {
      const isNeedBack =
        URLQueries.getQuery('__beatlesHome') &&
        +URLQueries.getQuery('__beatlesHome') === 1
      if (isNeedBack) {
        // goTo({
        //   path: '/sfc-homepage/pages/homepage',
        //   extParams: {
        //     moveType: 2,
        //   },
        // })
        window.wx &&
          window.wx.miniProgram.navigateBack({
            delta: 2,
          })
        wx &&
          wx.navigateBack({
            delta: 2,
          })
        window.my &&
          window.my.navigateBack({
            delta: 2,
          })
        return
      }
      goTo({
        path: '/sfc-homepage/pages/homepage',
      })
      return
    }
  }
  goTo({
    path: '/home/pages/dache',
    scheme: 'onetravel://dache_anycar/entrance',
    extParams: {
      xspmInfo,
    },
  })
}
